module.exports = __webpack_public_path__ + "img/portrait-background-remover-before.44e6a7aa.jpg";